import React from 'react';
import useApproverService from '@atlassian/jira-workflow-approvals/src/services/approver-service/index.tsx';
import { ApprovalStepView, type Props } from './view.tsx';

type OwnProps = Omit<Props, 'cachedApprovers' | 'onFetchApprovers'>;

export const ApprovalStep = (props: OwnProps) => {
	const [{ cachedApprovers }, { fetchApprovers }] = useApproverService();

	return (
		<ApprovalStepView
			{...props}
			cachedApprovers={cachedApprovers}
			onFetchApprovers={fetchApprovers}
		/>
	);
};
